import loadable from '@loadable/component';
import StatusIcon from '../../Icons/StatusIcon';
import useUserServiceGetHook from '../../customHooks/useUserServiceGetHook';
import APIS from '../../constant/EndPoint';

const CurrentUserProfileComponent = loadable(
  () => import("../../components/Auth/CurrentUserProfile")
);

const UserProfile = () => {
  const { data: profile } = useUserServiceGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });

  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">My Profile</span>
      </div>
      <CurrentUserProfileComponent
        profile={profile}
      />
    </>
  )
}

export default UserProfile
